// extracted by mini-css-extract-plugin
export default {"btnpwd":"_7de33047b0"};